import { useState } from "react";
import { selectCommunicationData } from "../../store";
import { useAppSelector } from "../../store/hooks";
import { FileItemType } from "../../types/communication/communicationDataType";
import FotoMultiSection from "../foto-multi-section/FotoMultiSection";
import { LiqPhotoTypeMapper, PhotoTypeEnum } from "../../types/commonTypes";

/* istanbul ignore next */
const FotoOtherUsefulInfo = () => {
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const [fotoOtherUsefulInfo, setFotoOtherUsefulInfo] = useState<FileItemType[]>(communication.fotoOtherUsefulInfo)

    return (
        <>
            <FotoMultiSection
                fileType={PhotoTypeEnum.OTHER_USEFUL_INFO_DOCS}
                additionalBeInfo={{
                    liqDocumentType: LiqPhotoTypeMapper[PhotoTypeEnum.OTHER_USEFUL_INFO_DOCS],
                    liqDescription: "Altro"
                }}
                files={fotoOtherUsefulInfo}
                setFiles={setFotoOtherUsefulInfo}
                arrayDbPropSync={"fotoOtherUsefulInfo"}
                textLabel={"Scatta foto"}
                titleImageDetail={"Foto altre informazioni"}
                minPhotoNumber={1}
            />
        </>
    )
}

export default FotoOtherUsefulInfo